export default async function ({ store, redirect, route }) {
  // eslint-disable-next-line
  console.log('isQuoteEmpty private', store.getters['quote/isQuoteEmpty'])

  if (store.getters['quote/isQuoteEmpty']) {
    await store.dispatch('quote/fetchQuote', route.params.quoteid)
    if (store.getters['quote/quoteError']) {
      return redirect('/')
    } else {
      await store.dispatch('quote/calculatePrice')
    }
  }
}
